// @flow

import { graphql, useFragment } from 'react-relay';
import { useLocale } from '../../hooks/locale';
import { translatePropertyType } from '../translate/propertyTypes';
import type { AggregatesListingH1_listing$key } from './__generated__/AggregatesListingH1_listing.graphql';

export const useAggregatesListingH1 = (
  listing: AggregatesListingH1_listing$key,
): string => {
  const { t } = useLocale();

  const {
    offerType,
    propertyType,
    propertyMainType,
    postcode,
    subLocality,
    route,
    streetNumber,
  } = useFragment(
    graphql`
      fragment AggregatesListingH1_listing on AggregatesListing {
        offerType
        postcode
        subLocality
        route
        streetNumber
        propertyMainType
        propertyType
      }
    `,
    listing,
  );

  const propertyCardTitle =
    offerType === 'buy'
      ? t('propertyTypeCardTitle_sell', {
          propertyType: translatePropertyType(
            t,
            propertyType ?? propertyMainType ?? '',
          ).propertyTypeSingularCapital,
        })
      : t('propertyTypeCardTitle_rent', {
          propertyType: translatePropertyType(
            t,
            propertyType ?? propertyMainType ?? '',
          ).propertyTypeSingularCapital,
        });

  return [
    propertyCardTitle,
    ' - ',
    postcode,
    [
      subLocality,
      route != null ? [route, streetNumber].filter(Boolean).join(' ') : null,
    ]
      .filter(Boolean)
      .join(', '),
  ].join(' ');
};
